export enum AnalysisGridDataView {
  MonthlyView = 'Monthly View',
  YearlyView = 'Yearly View',
}

export enum FinancialGridDataView {
  MonthlyView = 'Monthly View',
  YearlyView = 'Yearly View',
  ComparisonView = 'Comparison View',
}
export enum PlanningGridDataView {
  MonthlyView = 'Monthly View',
  YearlyView = 'Yearly View',
}
